export class TodoPlannerConfigModel {
  public defaultPlannerView = -1;
  public hideTodoEntryDetails = -1;
}
